import React from "react";
import { Select } from "antd";

export const sapTypes = [
  { id: 1, name: "New (SAP ID)", type: "New" },
  { id: 2, name: "Modification (SAP ID)", type: "Modification" },
  { id: 3, name: "Transfer of ID", type: "Transfer of ID" },
  { id: 4, name: "Sac ID", type: "Sac ID" },
  { id: 5, name: "SAP ID deactivation", type: "SAP ID deactivation" },
];

export default function SapTypeComponent({ onChange, value }) {
	return (
		<Select
			showSearch={true}
			optionFilterProp='children'
			style={{ width: "100%" }}
			size='large'
			placeholder='Please Select Type'
			value={value}
			onChange={onChange}
			allowClear
		>
			{sapTypes.map((item) => (
				<Select.Option key={item.id} value={item.id}>
					{item.name}
				</Select.Option>
			))}
		</Select>
	);
}
